import React, { FunctionComponent } from 'react';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconCheck: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faCheckCircle} />;

export { BrassIconCheck };
